<div class="p-2 m-2" *ngIf="noRule && tableDataSource && allCategories">
    <div class="Tabletitle">
        <span class="Tabletitle"> Rules ({{allRules.length}}) </span>
    </div>
    <div class="row">
        <button class="m-1" mat-raised-button (click)="newRule()">Create Rule</button>
        <div class="input-group-sm mt-2 input-group col-6">
            <input *ngIf="allRules" class="form-control" type="search" (keyup)="applyFilter($event)" placeholder="Filter">
        </div>
    </div>

    <div class="table-container mat-elevation-z8">
        <table mat-table matSort [dataSource]="tableDataSource" matSortActive="name" matSortDirection="asc"
            aria-describedby="rules-table">

            <!--- Note that these columns can be defined in any order.
    The actual rendered columns are set as a property on the row definition"-->

            <!-- Hold Name Column -->
            <ng-container matColumnDef="name">
                <th id="name" mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                <td mat-cell *matCellDef="let element"> {{element.rule_name}} </td>
            </ng-container>

            <!-- Event Column -->
            <ng-container matColumnDef="event">
                <th id="event" mat-header-cell *matHeaderCellDef mat-sort-header> Event </th>
                <td mat-cell *matCellDef="let element"> {{element.event_name}} </td>
            </ng-container>

            <!-- Category Column -->
            <ng-container matColumnDef="category">
                <th id="category" mat-header-cell *matHeaderCellDef mat-sort-header> Category </th>
                <td mat-cell *matCellDef="let element"> {{element.category}} </td>
            </ng-container>

            <!-- External ID Column -->
            <ng-container matColumnDef="exid">
                <th id="exid" mat-header-cell *matHeaderCellDef mat-sort-header> External ID </th>
                <td mat-cell *matCellDef="let element"> {{element['action_item']['exid']}} </td>
            </ng-container>

            <!-- Action Column -->
            <ng-container matColumnDef="actions">
                <th id="actions" mat-header-cell *matHeaderCellDef> Actions </th>
                <td mat-cell *matCellDef="let element" style="text-align: center;">
                    <mat-icon *ngIf="element.active" title="Update Rule" (click)="updateRule(element)">edit</mat-icon>
                    <mat-icon *ngIf="element.active" title="Delete Rule" (click)="deleteRule(element)">delete</mat-icon>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>
        <mat-paginator [pageSizeOptions]="[10, 20, 50]" [pageSize]="10" showFirstLastButtons></mat-paginator>
    </div>
</div>

<div *ngIf="!noRule && allCategories" class="card m-2">
    <form [formGroup]="ruleForm" class="card-body">
        <div class="input-group-sm mb-3 input-group col-12">
            <div class="input-group-prepend">
                <span class="input-group-text form-label-105">Name</span>
            </div>
            <input *ngIf="isEditable" formControlName="name" class="form-control">
            <input *ngIf="!isEditable" formControlName="name" class="form-control" readonly>
        </div>

        <div class="input-group-sm mb-3 input-group col-12">
            <div class="input-group-prepend">
                <span class="input-group-text form-label-105">Event</span>
            </div>
            <mat-select formControlName="eventName" class="form-control">
                <mat-option *ngFor="let eventName of eventNames" [value]="eventName">
                    {{eventName}}
                </mat-option>
            </mat-select>
        </div>

        <div class="input-group-sm mb-3 input-group col-12">
            <div class="input-group-prepend">
                <span class="input-group-text form-label-105">Category</span>
            </div>
            <mat-select formControlName="categoryId" [(ngModel)]=categoryID
                (selectionChange)="getCategoryProperties(categoryID)" (ngModelChange)="categoryID" class="form-control">
                <mat-option>
                    <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                        [noEntriesFoundLabel]="'Not found'" name="search" [ngModelOptions]="{standalone: true}">
                    </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let category of allCategories.results |stringFilter:searchCtrl:'name'"
                    [value]="category.id">
                    {{category.name}}
                </mat-option>
            </mat-select>
        </div>

        <div *ngIf="categoryID" class="card p-2 m-3 mb-2">
            <div formArrayName="attributeValues">
                <div class="form-group row">
                    <span class="form-group ml-3 form-label-105">Attributes</span>
                    <div class="col mb-2">
                        <button mat-stroked-button class="float-right" title="Add Form" (click)="addAttributeValue()">
                            <mat-icon>add</mat-icon>Add Attribute
                        </button>
                    </div>
                </div>
                <div *ngFor="let section of getAttributeValue(ruleForm); let i = index" [formGroupName]="i">
                    <div class="row">
                        <div class="col-5">
                            <div class="input-group-sm mb-3 input-group col">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">Attribute</span>
                                </div>
                                <mat-select formControlName="attribute" class="form-control">
                                    <mat-option>
                                        <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                                            [noEntriesFoundLabel]="'Not found'" name="search"
                                            [ngModelOptions]="{standalone: true}">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option
                                        *ngFor="let property of categoryProperties |stringFilter:searchCtrl:'name'"
                                        [value]="property">
                                        {{property}}
                                    </mat-option>
                                </mat-select>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="input-group-sm mb-3 input-group col">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">Value</span>
                                </div>
                                <input class="form-control" type="text" formControlName="value">
                            </div>
                        </div>
                        <div class="col-1">
                            <mat-icon (click)="deleteAttributeValue(i)">delete</mat-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="input-group-sm mb-3 input-group col-12">
            <div class="input-group-prepend">
                <span class="input-group-text">External Connection</span>
            </div>
            <mat-select formControlName="externalId" class="form-control">
                <mat-option *ngFor="let extConn of allExternalConnections" [value]="extConn.system_id">
                    {{extConn.system_name}}
                </mat-option>
            </mat-select>
        </div>

        <button mat-raised-button class="backButton m-1" (click)="back()">Back</button>
        <button mat-raised-button class="actionButton m-1" (click)="save()">{{button}}</button>

    </form>
</div>